/**
 * FlightAware API Configuration
 * 
 * To enable flight tracking:
 * 1. Sign up for FlightAware AeroAPI at https://www.flightaware.com/aeroapi/portal/
 * 2. Get your API key from the dashboard
 * 3. Set the API key in your environment variables or configuration
 */

// FlightAware API Configuration
export const FLIGHTAWARE_CONFIG = {
  // API Key - Set this in your environment or configuration
  API_KEY: process.env.REACT_APP_FLIGHTAWARE_API_KEY || '',
  
  // API Base URL
  BASE_URL: 'https://aeroapi.flightaware.com/aeroapi',
  
  // Default refresh intervals (in milliseconds) - Optimized for cost reduction
  REFRESH_INTERVALS: {
    ACTIVE_FLIGHT: 300000,   // 5 minutes for flights in progress
    SCHEDULED_FLIGHT: 300000, // 5 minutes for scheduled flights
    COMPLETED_FLIGHT: 600000  // 10 minutes for completed flights
  },
  
  // Feature flags
  FEATURES: {
    ENABLE_FLIGHT_TRACKING: true,
    ENABLE_REAL_TIME_UPDATES: true,
    ENABLE_FLIGHT_ALERTS: true,
    ENABLE_AIRPORT_DELAYS: true,
    ENABLE_WEATHER_INFO: false, // Requires additional API calls
    ENABLE_LIVE_POSITION: true
  },
  
  // Alert thresholds
  ALERT_THRESHOLDS: {
    DELAY_MINUTES: 15,        // Alert for delays over 15 minutes
    CANCELLATION: true,       // Alert for cancellations
    DIVERSION: true,          // Alert for diversions
    GATE_CHANGE: true,        // Alert for gate changes
    TERMINAL_CHANGE: true     // Alert for terminal changes
  },
  
  // API Rate Limits (requests per minute)
  RATE_LIMITS: {
    FREE_TIER: 10,           // Free tier limit
    BASIC_TIER: 100,         // Basic tier limit
    PREMIUM_TIER: 1000       // Premium tier limit
  }
};

// Check if FlightAware is properly configured
export const isFlightAwareConfigured = () => {
  return FLIGHTAWARE_CONFIG.API_KEY && FLIGHTAWARE_CONFIG.API_KEY.length > 0;
};

// Get appropriate refresh interval based on flight status
export const getRefreshInterval = (flightStatus) => {
  if (!flightStatus) return FLIGHTAWARE_CONFIG.REFRESH_INTERVALS.SCHEDULED_FLIGHT;
  
  const status = flightStatus.status?.toLowerCase();
  
  if (status === 'departed' || status === 'in flight') {
    return FLIGHTAWARE_CONFIG.REFRESH_INTERVALS.ACTIVE_FLIGHT;
  }
  
  if (status === 'arrived' || status === 'completed') {
    return FLIGHTAWARE_CONFIG.REFRESH_INTERVALS.COMPLETED_FLIGHT;
  }
  
  return FLIGHTAWARE_CONFIG.REFRESH_INTERVALS.SCHEDULED_FLIGHT;
};

export default FLIGHTAWARE_CONFIG;
